"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPageNumber = exports.isLogText = exports.isLatexmkError = exports.isTexError = exports.isFileStack = void 0;
function isFileStack(e) {
    return e.kind === 'file_stack';
}
exports.isFileStack = isFileStack;
function isTexError(e) {
    return e.kind === 'tex_error';
}
exports.isTexError = isTexError;
function isLatexmkError(e) {
    return e.kind === 'latexmk_error';
}
exports.isLatexmkError = isLatexmkError;
function isLogText(e) {
    return e.kind === 'text_string';
}
exports.isLogText = isLogText;
function isPageNumber(e) {
    return e.kind === 'page_number';
}
exports.isPageNumber = isPageNumber;
//# sourceMappingURL=latex_log_types.js.map